/**
 * Guard against double execution.
 * Returns a wrapper that ignores calls while a previous invocation is still "active".
 */
export function createIdempotencyGuard() {
  let locked = false;

  return {
    /** Try to acquire the lock. Returns true if acquired, false if already locked. */
    tryAcquire(): boolean {
      if (locked) return false;
      locked = true;
      return true;
    },
    /** Release the lock. */
    release(): void {
      locked = false;
    },
    /** Check if currently locked. */
    isLocked(): boolean {
      return locked;
    },
  };
}
